<iframe id="my_iframe" [src]="url" width="100%" height="100%" target="_parent" frameborder="0"  cellspacing="0" class="ac-speedpayiframe"
style="border-style: none;background-color: #ffffff!important;height:65rem" allowfullscreen >
</iframe>
 